import { useEffect, useState } from "react";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import { requestGetContactById, requestUpdateContactCart } from "../../Redux/actions";
import { bindActionCreators } from "redux";
import { add } from "date-fns";
import { o } from "@table-library/react-table-library/styles-492c6342";

function ContactView(props) {
    const [contact, setContact] = useState(null);
    const [error, seterror] = useState("");
    const [erroraddress, seterroraddress] = useState("");
    const [errorzipcode, seterrorzipcode] = useState("");
    const [errorroomno, seterrorroomno] = useState("");    
    const [errorphoneno, seterrorphone_no] = useState("");
    const [erroremail, seterroremail] = useState("");
    const [id, setid] = useState(0);
    const [addressId, setaddressId] = useState(0);
    const [addmodal, setaddModal] = useState(false);
    const [user, setuser] = useState(null);
    const [adddata, setadddata] = useState({
        clientName: "", emailID: "", phoneNo: "", roomNo: "", address: "", zipcode: "", orderType: "daily", token: "" 
    });

    useEffect(() => {
        if (props.props) {
            setid(props.props);
            let data1 = JSON.parse(localStorage.getItem("user"));
            setuser(data1);
            props.requestGetContactById({
                data: {
                    param1: props.props.toString(),
                    token: data1.data.userToken
                },
            });
        }
    }, [props.props]);

    useEffect(() => {
        let jobsData = props.data.getContactByIdData;
        console.log("jobsData", jobsData.data.data);
        if (jobsData !== undefined) {
            if (jobsData.data) {
                setContact(jobsData.data.data);
            }
        }
    }, [props.data.getContactByIdData]);

    function validateadd() {
        let formIsValid = false;
        if (!contact.clientName) {
            formIsValid = false;
            seterror("*Enter Contact Name.");
        } else {
            formIsValid = true;
            seterror("");
        }
        return formIsValid;
    }

    function validateEmail() {
        let formIsValid = false;
        if (!contact.emailID) {
            formIsValid = false;
            seterroremail("*Enter Contact email.");
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(contact.emailID)) {
            formIsValid = false;
            seterroremail("*Enter valid email.");
        } else {
            formIsValid = true;
            seterroremail("");
        }
        return formIsValid;
    }
    function validatePhoneNo() {
        let formIsValid = false;
        if (!contact.phoneNo) {
            formIsValid = false;
            seterrorphone_no("*Enter Contact phone no.");
        } else if (!/^\d{10}$/.test(contact.phoneNo)) {            
            formIsValid = false;
            seterrorphone_no("*Enter valid phone no.");
        } else {
            formIsValid = true;
            seterrorphone_no("");
        }
        return formIsValid;
    }

    function validateaddress() {
        let formIsValid = false;
        if (addressId === "0") {
            formIsValid = false;
            seterroraddress("*Select contact address.");
        } else if (typeof addressId === "undefined") {
            formIsValid = false;
            seterroraddress("*Select contact address.");
        } else {
            formIsValid = true;
            seterroraddress("");
        }
        return formIsValid;
    }

    function validatezipcode() {
        let formIsValid = false;
        if (!contact.zipcode) {
            formIsValid = false;
            seterrorzipcode("*Enter Contact zipcode.");
        } else if (!/^\d{6}$/.test(contact.zipcode)) {
            formIsValid = false;
            seterrorzipcode("*Enter valid zipcode.");
        } else {
            formIsValid = true;
            seterrorzipcode("");
        }
        return formIsValid;
    }

    function validateroomNo() {
        let formIsValid = false;
        if (!contact.roomNo) {
            formIsValid = false;
            seterrorroomno("*Enter Room No.");
        } else if (/^.$/.test(contact.roomNo)) {
            formIsValid = false;
            seterrorroomno("*Enter valid Room No.");
        } else {
            formIsValid = true;
            seterrorroomno("");
        }
        return formIsValid;
    }

    function validateAddForm() {
        let validate = validateadd(); let phone = validatePhoneNo(); let address = validateaddress(); let zipcode = validatezipcode();
        let roomNo = validateroomNo();
        let valid = validate && address && phone && zipcode && roomNo;
        console.log("valid", validate, phone, address, zipcode, roomNo);
        if (!valid) {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Please fill all the required fields correctly.",
            });
        }
        return valid;
    }
    function onchangeadddata(e) {
        setadddata((adddata) => ({
            ...adddata,
            [e.target.name]: e.target.value,
        }));
    }
    const addtoggle = () => setaddModal(!addmodal);
    const saveaddtoggle = (e) => {
        e.preventDefault();
        console.log("adddata", contact);
        if (validateAddForm()) {
            props.requestUpdateContactCart({
                data: {
                    userToken: user.data.userToken,
                    token: contact.token,
                    clientName: contact.clientName,
                    zipcode: contact.zipcode,
                    address: contact.address,
                    roomNo: contact.roomNo,
                    emailID: contact.emailID,
                    phoneNo: contact.phoneNo,
                    orderType: contact.orderType,
                },
            });
            setadddata({
                clientName: "",
                address: "",
                roomNo: "",
                email: "",
                phoneno: "",
                zipcode: "",
                orderType: "daily",
                token: "",
            });
            addtoggle();
        }
    };

    useEffect(() => {
        let candidateprofile = props.data.updateContactCartData;
        console.log(props.data.updateContactCartData);
        if (candidateprofile !== undefined) {
            if (candidateprofile?.data?.status == 1) {
                Swal.fire("Good job!", "Contact updated Successfully.", "success");
                props.data.updateContactCartData = undefined;
            } else {
                Swal.fire("Error!", `${candidateprofile.data.message}`, "error");
            }
        }
    }, [props.data.updateContactCartData]);

    function onchangeeditdata(e) {
        if (e.target.type === 'radio') {
            console.log(e.target.value);
            setContact((data) => ({
                ...data,
                [e.target.name]: e.target.value,
            }));
        } else {
            setContact((data) => ({
                ...data,
                [e.target.name]: e.target.value,
            }));
        }
    }

    return (
        contact === null ? <div>Loading...</div> : 
        <div className="contact-view">
            <h6>{contact.clientName ? (contact.clientName) : ""}</h6>
            <form class="forms-sample">
                <div class="form-group">
                    <label>Name</label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="Name"
                        name="clientName"
                        value={contact.clientName}
                        onBlur={validateadd}
                        onChange={onchangeeditdata}
                    />
                    {error && <p>{error}</p>}
                    <label> <br /> Room No. </label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="Room no"
                        name="roomNo"
                        value={contact.roomNo}
                        onBlur={validateroomNo}
                        onChange={onchangeeditdata}
                    />
                    {errorroomno && <p>{errorroomno}</p>}
                    <label> <br /> Address </label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="Address"
                        name="address"
                        value={contact.address}
                        onBlur={validateaddress}
                        onChange={onchangeeditdata}
                    />
                    {erroraddress && <p>{erroraddress}</p>}
                    <label> <br /> Zip code </label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="Zipcode"
                        name="zipcode"
                        value={contact.zipcode}
                        onBlur={validatezipcode}
                        onChange={onchangeeditdata}
                    />
                    {errorzipcode && <p>{errorzipcode}</p>}
                    <label> <br /> Email </label>
                    <input
                        type="email"
                        class="form-control"
                        placeholder="Email"
                        name="emailID"
                        value={contact.emailID}
                        onChange={onchangeeditdata}
                    />
                    <label> <br /> Phone No </label>
                    <input
                        type="tel"
                        class="form-control"
                        placeholder="Phone No"
                        name="phoneNo"
                        value={contact.phoneNo}
                        onBlur={validatePhoneNo}
                        onChange={onchangeeditdata}
                    />
                    {errorphoneno && <p>{errorphoneno}</p>}
                    <div class="form-check form-check-inline">
                        <input
                            class="form-check-input"
                            type="radio"
                            style={{ margin: "0px" }}
                            id="daily"
                            name="orderType"
                            value="daily"
                            checked={contact.orderType === "daily"}
                            onChange={onchangeeditdata}
                        />
                        <label class="form-check-label">Daily</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input
                            class="form-check-input"
                            type="radio"
                            style={{ margin: "0px" }}
                            id="alternate"
                            name="orderType"
                            value="alternate"
                            // onBlur={validategender}
                            checked={contact.orderType === "alternate"}
                            onChange={onchangeeditdata}
                        />
                        <label class="form-check-label">Alternate</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input
                            class="form-check-input"
                            type="radio"
                            style={{ margin: "0px" }}
                            id="onetime"
                            name="orderType"
                            value="onetime"
                            // onBlur={validategender}
                            checked={contact.orderType === "onetime"}
                            onChange={onchangeeditdata}
                        />
                        <label class="form-check-label">One Time</label>
                    </div>
                </div>
                <button
                    type="submit"
                    class="btn btn-primary me-2"
                    onClick={saveaddtoggle}
                >
                    Submit
                </button>
                <button
                    class="btn btn-light"
                    onClick={addtoggle}
                >
                    Cancel
                </button>
            </form>
        </div>
    )
}

const mapStateToProps = (state) => {
    return { data: state.data };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({ requestGetContactById, requestUpdateContactCart }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ContactView);